
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/remyndScrapeCategory",
      function () {
        return require("private-next-pages/remyndScrapeCategory/index.tsx");
      }
    ]);
  